import { ButtonProps, Flex, Text } from '@chakra-ui/react';
import { memo } from 'react';
import { CiCalendar } from 'react-icons/ci';

import FilterPillPopover from '@components/common/FilterPillPopover';

const CalendarPickerPillButtonContent = ({ width }: { width?: ButtonProps['width'] }) => {
  return <Text width={width}>2025-01-01</Text>;
};

interface Props {
  title: string | React.ReactNode;
  width?: ButtonProps['width'];
}
const CalendarPickerPill = ({ title, width }: Props) => {
  return (
    <Flex flexDir="column" gap={1} align="start">
      {typeof title === 'string' ? (
        <Text fontSize="sm" fontWeight="light">
          {title}
        </Text>
      ) : (
        title
      )}
      <FilterPillPopover
        isActive={false}
        leftIcon={<CiCalendar size={4} />}
        rightIcon={<Flex />}
        buttonContent={<CalendarPickerPillButtonContent width={width} />}
      >
        TODO
      </FilterPillPopover>
    </Flex>
  );
};

export default memo(CalendarPickerPill);
